import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { toast } from "sonner";
import { LogoMark } from "@/components/site/Logo";
import { MaskLine } from "@/components/site/motion";
import { ProfileCard } from "@/components/account/ProfileCard";
import { AddressCard } from "@/components/account/AddressCard";
import { OrdersList } from "@/components/account/OrdersList";
import { useAccount } from "@/context/AccountContext";

const headerBtn = "flex h-10 items-center gap-2 border border-line px-3 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors hover:border-acid";

export default function AccountProfile() {
  const { customer, logout } = useAccount();
  const navigate = useNavigate();

  const signOut = async () => {
    await logout();
    toast("Sei uscito dal tuo account");
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen" data-testid="account-profile-page">
      <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-line bg-ink/85 px-5 backdrop-blur-xl sm:px-8 lg:px-12">
        <Link to="/" className="flex items-center gap-2.5" data-testid="account-profile-home-link">
          <LogoMark className="h-8 w-8" />
          <span className="font-display text-sm font-black tracking-[0.2em]">SFUMO</span>
        </Link>
        <div className="flex items-center gap-2">
          <Link to="/" className={headerBtn} data-testid="account-back-site-link">
            <ArrowLeft className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Torna al sito</span>
          </Link>
          <button onClick={signOut} data-testid="account-logout-button" className={headerBtn}>
            <LogOut className="h-3.5 w-3.5" /> Esci
          </button>
        </div>
      </header>

      <main className="px-5 py-12 sm:px-8 lg:px-12 lg:py-16">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-smoke">Il tuo account</p>
        <h1 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl" data-testid="account-greeting">
          <MaskLine onLoad>Ciao,</MaskLine>
          <MaskLine onLoad delay={0.1} className="break-words text-acid">{customer.name.split(" ")[0]}.</MaskLine>
        </h1>
        <div className="mt-12 grid gap-6 lg:grid-cols-12">
          <div className="space-y-6 lg:col-span-5">
            <ProfileCard />
            <AddressCard />
          </div>
          <div className="lg:col-span-7">
            <OrdersList />
          </div>
        </div>
      </main>
    </div>
  );
}
